module.exports = __webpack_public_path__ + "static/fa-light-300-3d8af27a47bbfab857f96dbcf710b087.woff2";